import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../../dashboard.selectors';
import * as fromTiimStudyParticipant from './tiim-study-participant.reducer';

export const selectTiimStudyParticipantState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.tiimStudyParticipant
);

export const selectIsLoadingTiimStudyParticipants = createSelector(
  selectTiimStudyParticipantState,
  (tiimStudyParticipantState) => tiimStudyParticipantState?.loadingTiimStudyParticipants
);

export const selectTiimStudyParticipantsLoaded = createSelector(
  selectTiimStudyParticipantState,
  (tiimStudyParticipantState) => tiimStudyParticipantState?.tiimStudyParticipantsLoaded
);

export const selectTiimStudyParticipants = createSelector(
  selectTiimStudyParticipantState,
  fromTiimStudyParticipant.selectAll
);

export const selectSelectedTiimStudyParticipant = createSelector(
  selectTiimStudyParticipantState,
  (tiimStudyParticipantState) => tiimStudyParticipantState?.selectedTiimStudyParticipant
);

export const selectIsSingleParticipantVisible = createSelector(
  selectTiimStudyParticipantState,
  (tiimStudyParticipantState) => tiimStudyParticipantState?.singleParticipantVisible
);
